import { ButtonHTMLAttributes, ReactNode } from 'react';
import { classNames } from '@/utils/classNames';
import styles from './Button.module.css';

export type ButtonVariant =
  | 'solid'
  | 'subtle'
  | 'outline'
  | 'outlineNeutral'
  | 'destructive'
  | 'ghost'
  | 'ghostOnImage'
  | 'outlineOnImage';

export type ButtonSize = 'large' | 'medium';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  size?: ButtonSize;
  loading?: boolean;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
};

export const Button = ({
  variant = 'solid',
  size = 'large',
  loading = false,
  leftIcon,
  rightIcon,
  children,
  disabled,
  className,
  type = 'button',
  ...rest
}: ButtonProps) => (
  <button
    type={type}
    className={classNames(
      styles.button,
      styles[variant],
      styles[size],
      loading && styles.isLoading,
      className,
    )}
    disabled={disabled || loading}
    aria-busy={loading || undefined}
    {...rest}
  >
    {loading ? (
      <span className={styles.spinner} aria-hidden />
    ) : (
      <>
        {leftIcon && <span className={styles.icon}>{leftIcon}</span>}
        <span className={styles.label}>{children}</span>
        {rightIcon && <span className={styles.icon}>{rightIcon}</span>}
      </>
    )}
  </button>
);
